module.exports = __webpack_public_path__ + "static/media/ken_kralick.2b7f26f7.png";